import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-nmj-finished',
    templateUrl: './nmj-finished.component.html',
    styleUrls: ['./nmj-finished.component.scss'],
    imports: [
        NgTemplateOutlet
    ],
})
export class NmjFinishedComponent
    extends ComponentBase
    implements OnInit, OnDestroy {

    constructor(public store: Store<AppState>) {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }

    goBackToHome() {
        window.location.href = 'https://vervesuper.com.au/';
    }
}
